'use-strict';

const { weightedAverage, normalizeInverse0100 } = require('../utils/math');
const Protocol = require('./protocol');
const QuestionProtocolCalculator = require('./question-protocol');
const config = require('../data/emotional-config.json');

const EmotionalQuestionProtocol = new QuestionProtocolCalculator((_evaluation, _gender, _age, answerScore) => {
    if (answerScore <= 10) return 100;
    if (answerScore >= 30) return 20;
    return config.scoreMap[String(answerScore)];
}, config.questions);

class EmotionalProtocol extends Protocol {
    constructor() {
        super();
        this.questions = EmotionalQuestionProtocol.questions;
        this.distressFactors = config.distressFactors;
    }

    getScore(evaluation, gender, age, data) {
        const { answers, vass, distressFactors } = data;
        const { data: answerData } = EmotionalQuestionProtocol.getScore(evaluation, gender, age, answers);
        const baseScore = answerData.score;
        const vassScore = normalizeInverse0100(vass || 0, 0, 10);
        const score = weightedAverage([baseScore, vassScore], [config.answerCoeff, config.vassCoeff]);
        const selfRegulationDifficultiesAnswerScore = EmotionalQuestionProtocol.getAnswerScoreForQuestions(answers, [1, 2, 3, 4]);
        const performanceConcernsAnswerScore = EmotionalQuestionProtocol.getAnswerScoreForQuestions(answers, [5, 6, 7, 8]);
        const externalisedCopingAnswerScore = EmotionalQuestionProtocol.getAnswerScoreForQuestions(answers, [9, 10]);
        
        return {
            logs: data,
            data: {
                ...answerData,
                score: score,
                vass: vass,
                distressFactors: distressFactors,
                selfRegulationDifficultiesAnswerScore,
                performanceConcernsAnswerScore,
                externalisedCopingAnswerScore,
            }
        };
    }

    validateResults(body) {
        if(!EmotionalQuestionProtocol.validateResults(body)) return false;
        if(!this.validateFactors(body.distressFactors, this.distressFactors)) return false;
        return true;
    }

    getAnswerScore(questionOrder, answerId) { return EmotionalQuestionProtocol.getAnswerScore(questionOrder, answerId); }
    getScoreRange() { return EmotionalQuestionProtocol.getScoreRange(); }
    getSelfRegulationDifficulties() { return EmotionalQuestionProtocol.getScoreRange([1, 2, 3, 4]); }
    getPerformanceConcerns() { return EmotionalQuestionProtocol.getScoreRange([5, 6, 7, 8]); }
    getExternalisedCoping() { return EmotionalQuestionProtocol.getScoreRange([9, 10]); }

    getQuestionOrders() { return EmotionalQuestionProtocol.getQuestionOrders(); }
    getAnswerValuesPerQuestion() { return EmotionalQuestionProtocol.getAnswerValuesPerQuestion(); }
    getAnswerIdsPerQuestion() { return EmotionalQuestionProtocol.getAnswerIdsPerQuestion(); }
}


module.exports = new EmotionalProtocol();